/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CargoDto } from './CargoDto';
import type { SteamShipLineDto } from './SteamShipLineDto';
export type DeliveryOrderDto = {
    billOfLadingNumber?: string;
    bookingNumber?: string;
    cargo?: CargoDto;
    date?: string;
    docNumber?: string;
    equipmentFirstPickupDate?: string;
    firstReceivingDate?: string;
    generalCutoffDate?: string;
    id?: string;
    lastFreeDateDemurrage?: string;
    lastFreeDatePerDiem?: string;
    steamShipLine?: SteamShipLineDto;
    type?: DeliveryOrderDto.type;
    updatedAt?: string;
    vesselArrivalDate?: string;
};
export namespace DeliveryOrderDto {
    export enum type {
        IMPORT = 'IMPORT',
        EXPORT = 'EXPORT',
        REPOSITION = 'REPOSITION',
    }
}

